import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { useFormattedDate } from '../../hooks/useFormattedDate.js';

export const DateTimeSpan: FC<{ date: string }> = ({ date }) => {
  const { t } = useTranslation('@myn/import-hub');
  const { getFormattedDateWithTime } = useFormattedDate();
  return <time dateTime={date}>{getFormattedDateWithTime(date, t('at'))}</time>;
};
